import { MonthlyOrderStatsForStoreDoc, StoreDoc } from '@gooduncles/gu-app-schema';
import { DeliverySpotDoc } from '@gooduncles/gu-app-schema';
import { FC, useEffect, useState } from 'react';
import { combineLatest, from } from 'rxjs';

import { getMonthlyOrderStatsForStore, observeDeliverySpot, observeStore } from 'src/utils/firebase/firebase-short-cut';

import StoreTable from './StoreTable/StoreTable';

const Store: FC = () => {
  const [rowData, setRowData] = useState<
    (StoreDoc & { stats: MonthlyOrderStatsForStoreDoc | undefined; deliverySpot: DeliverySpotDoc | undefined })[]
  >([]);
  const [deliverySpots, setDeliverySpots] = useState<DeliverySpotDoc[]>([]);
  const year = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const prevMonth = currentMonth === 0 ? 12 : currentMonth;

  useEffect(() => {
    const orderStatsObservable = from(
      getMonthlyOrderStatsForStore([
        ['year', '==', prevMonth === 12 ? year - 1 : year],
        ['month', '==', prevMonth],
      ])
    );
    const storeObservable = observeStore();
    const deliveryObservable = observeDeliverySpot([['isDeleted', '==', false]]);
    const subscription = combineLatest([orderStatsObservable, storeObservable, deliveryObservable]).subscribe(
      ([orderStats, stores, spots]) => {
        const storeWithStats = stores.map((store) => {
          const stats = orderStats.find((stat) => stat.storeId === store._id);
          return {
            ...store,
            stats,
            deliverySpot: spots.find((spot) => spot._id === store.deliverySpotId),
          };
        });
        setDeliverySpots(spots);
        setRowData(storeWithStats);
      }
    );
    return () => subscription.unsubscribe();
  }, [prevMonth, year]);

  return <StoreTable rowData={rowData} deliverySpots={deliverySpots} />;
};

export default Store;
